export default __webpack_public_path__ + "static/media/logo.0891c4e9.png";